import { atom } from "recoil";
import { User } from "../Interfaces";
import {
  loadCurrentUser,
  loadEmojis,
} from "./Selectors";

export const emojisState = atom({
  key: 'emojisState',
  default: loadEmojis
});

export const currentUserState = atom<User>({
  key: 'currentUserState',
  default: loadCurrentUser
});

export const geoLocationState = atom({
  key: 'geoLocation',
  default: { latitude: 0, longitude: 0 }
});